export const ANALYTICS_QUERY_KEYS = {
  default: () => ['analytics'] as const,
  trackEvent: () => [...ANALYTICS_QUERY_KEYS.default(), 'trackEvent'] as const,
} as const;
